import { graphql } from '@/generated/gql';

export const CREATE_SAVING_MUTATION = graphql(/* GraphQL */ `
  mutation CreateSaving($input: SavingInput!) {
    createSaving(input: $input) {
      id
      name
      description
      status
      savingType
      currency
      baselinePrice
      newPrice
      baselineQuantity
      newQuantity
      validFrom
      validTo
      createdAt
      updatedAt
      fkBuyer
      fkSupplier
      fkCommodityGroup
      freeTextCommodity
      fkProcurementOrganization
      fkOrganization
      fkPurchasingGroup
      fkAccountingArea
      fkUnit
      originalPriceQuantity
      newPriceQuantity
      reductionType
      costAllocation {
        distributionType
        allocationValue
        fkAccountAssignmentCategory
        fkAccountAssignment
        fkGeneralLedgerAccount
      }
      sourceReferences {
        fkSourceSystem
        isPrimary
        sourceContext
        sourceReference
        sourceReferenceItem
        synchronizedAt
      }
    }
  }
`);
